import styled from "styled-components";

export const ChipsBase = styled.div`
  position: relative;
  padding: ${(props) => (props.padding ? props.padding : "0px 12px")};
  cursor: ${(props) => props.cursor};
  text-align: center;
  align-items: center;
  display: inline-flex;
  border-radius: 50px;
  padding-inline-end: ${(props) => props.paddingEnd};
  padding-inline-start: ${(props) => props.paddingStart};
  ${(props) => props.baseStyle};
  ${(props) => props.hoverStyle};
`;

export const IconStyle = styled.div`
  display: flex;
  cursor: ${(props) => props.cursor};
  padding: ${(props) => props.padding};
  margin-inline-start: ${(props) => props.margin};
  border-radius: 50%;
  &:hover {
    background-color: ${(props) => props.hoverBgColor};
  }
`;

export const HoverElementWrapper = styled.div`
  position: absolute;
  top: 30px;
  z-index: 1;
  visibility: ${(props) => (props.isShow ? `visible` : `hidden`)};
  opacity: ${(props) => (props.isShow ? 1 : 0)};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  text-align: start;
  ${(props) => props.position};
`;

export const Text = styled.span`
  font-size: ${(props) => props.fontSize};
  font-family: Arial, arimo;
  font-weight: 400;
  line-height: normal;
  text-decoration: inherit;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: inherit;
  display: flex;
  align-items: center;
  margin: 0px;
`;
